import React, { useContext, useEffect } from "react";
import { TemplateContext } from "../layout";
import ProductCardNew from "./productCards/productCardNew";
import ProductCardVariant from "./productCards/productCardVariant";

const ProductsList = ({ modifications }) => {
  const [templateContext, setTemplateContext, variantsContext, setVariantsContext] = useContext(TemplateContext);
  useEffect(() => {
    const groupedData = variantsContext?.variants
      ?.slice(0, templateContext?.config?.product?.amount)
      .reduce((acc, curr) => {
        const key = `${curr?.size && curr?.size}-${curr?.color && curr?.color}`;
        if (!acc[key]) {
          acc[key] = {
            size: curr?.size,
            sizeLabel: curr?.sizeLabel,
            color: curr?.color,
            colorLabel: curr?.colorLabel,
            amount: 0,
          };
        }
        acc[key].amount++;
        return acc;
      }, {});

    setVariantsContext({
      ...variantsContext,
      calculatedData: groupedData,
    });
  }, [variantsContext.variants, templateContext?.config?.product?.amount]);

  const variantsEnabled = window?.productData?.enable_size_variants || window?.productData?.enable_color_variants;
  return (
    <div className="product-list-drawer">
      {variantsEnabled &&
        variantsContext?.calculatedData &&
        Object.values(variantsContext?.calculatedData).map((item, index) => {
          return <ProductCardVariant key={index} product={templateContext?.config?.product} variant={item} />;
        })}
      {templateContext?.config?.product && !variantsEnabled && (
        <ProductCardNew product={templateContext.config.product} index={1} />
      )}
      {templateContext?.config?.product?.fake_products &&
        templateContext?.config.product?.enable_fake_products &&
        templateContext.config.product.fake_products.map((product, index) => (
          <ProductCardNew product={product} key={index} modifications={modifications} type="fake" />
        ))}
    </div>
  );
};

export default ProductsList;
